"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLoader = exports.ImageStatus = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var loadImage_1 = require("./loadImage");
var ImageStatus;
(function (ImageStatus) {
    ImageStatus[ImageStatus["INITIAL"] = 0] = "INITIAL";
    ImageStatus[ImageStatus["LOADING"] = 1] = "LOADING";
    ImageStatus[ImageStatus["LOADED"] = 2] = "LOADED";
    ImageStatus[ImageStatus["ERROR"] = 3] = "ERROR";
})(ImageStatus = exports.ImageStatus || (exports.ImageStatus = {}));
var ImageLoader = /** @class */ (function (_super) {
    tslib_1.__extends(ImageLoader, _super);
    function ImageLoader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            status: ImageStatus.INITIAL,
            src: '',
        };
        return _this;
    }
    ImageLoader.getDerivedStateFromProps = function (props, state) {
        if (props.src !== state.src) {
            return {
                status: props.src ? ImageStatus.INITIAL : ImageStatus.ERROR,
                src: props.src,
            };
        }
        return null;
    };
    ImageLoader.prototype.componentDidMount = function () {
        this._isMounted = true;
        if (this.state.status === ImageStatus.INITIAL) {
            void this.loadSrc();
        }
    };
    ImageLoader.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.status === ImageStatus.INITIAL) {
            void this.loadSrc();
        }
    };
    ImageLoader.prototype.loadSrc = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            status: ImageStatus.LOADING,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, loadImage_1.loadImage(this.state.src)];
                    case 2:
                        _a.sent();
                        if (this._isMounted) {
                            this.setState({
                                status: ImageStatus.LOADED,
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (this._isMounted) {
                            this.setState({
                                status: ImageStatus.ERROR,
                            });
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ImageLoader.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    ImageLoader.prototype.render = function () {
        var _a = this.props, src = _a.src, children = _a.children;
        var status = this.state.status;
        return children({ src: src, status: status });
    };
    return ImageLoader;
}(React.Component));
exports.ImageLoader = ImageLoader;
//# sourceMappingURL=ImageLoader.js.map